import React from 'react';

import productApi from 'app/api/productApi';
import Page from 'app/components/misc/BasePage';
import PageHead from 'app/components/misc/PageHead';
import ProductSitemapContent from 'app/pageContents/ProductSitemapContent';
import { PRODUCT_FILTER_TYPE } from 'app/constants/product';
import buildConfig from 'app/utils/buildConfig';

const ProductSitemap = ({ products, pagination }) => {
  return (
    <Page>
      <PageHead
        pageTitle="Financial Products Sitemap - "
        canonicalUrl={`${buildConfig.apiHost}/sitemap/products/`}
      />
      <ProductSitemapContent products={products} pagination={pagination} />
    </Page>
  );
};

ProductSitemap.getInitialProps = async ({ query }) => {
  const { page } = query;
  try {
    const response = await productApi.getProducts(
      {
        page,
        per: 100,
        sort: {
          by: PRODUCT_FILTER_TYPE.MOST_POPULAR,
          dir: 'asc',
        },
      },
      { headers: {} },
    );

    if (response.data.code === 'ok') {
      return {
        products: response.data.data,
        pagination: response.data.meta.pagination,
      };
    }
  } catch (e) {
    console.log('e', e);
  }
};

export default ProductSitemap;
